module.exports = __webpack_public_path__ + "static/media/wizualizacja-123.797ddea2.png";